import React, { useState, useEffect } from "react";

import IconeApp from "../assets/img/icone-app.png";

import Corpo from "../components/Corpo";

import { getUserSession } from "../services/user-service";
import { getVersion } from "../services/version";

export default function TabSobre(props) {
  const [usuario, setUsuario] = useState({});
  const [version, setVersion] = useState("");

  useEffect(() => {
    getUserSession().then((res) => {
      setUsuario(res.data);
    });
    getVersion().then((res) => {
      if (res?.data?.version) {
        setVersion(res.data.version);
      }
    });
  }, []);

  return (
    <Corpo {...props}>
      <div name="tab-inicio" className="view-container tab-content">
        <div className="view-perguntas pane pane-game">
          <div
            className="scroll-content ionic-scroll  has-tabs-top"
            style={{ top: "56px" }}
          >
            <div
              className="scroll"
              style={{ transform: "translate3d(0px, 0px, 0px) scale(1)" }}
            >
              <h2>Sobre</h2>
              <div className="list card">
                <div className="item item-thumbnail-left">
                  <img src={IconeApp} alt="icone app" />
                  <h3>ConheciGame</h3>
                  <p>versão: {version}</p>
                  <p>
                    <b
                      onClick={() =>
                        window.open("https://uc.sebrae.com.br", "_blank")
                      }
                      style={{ color: "#666", cursor: "pointer" }}
                    >
                      Universidade Corporativa Sebrae
                    </b>
                  </p>
                </div>
                <div className="item item-divider item-positive">Usuário</div>
                <div className="item item-text-wrap">
                  <ul style={{ color: "#000" }}>
                    <li style={{ color: "#000" }}>{usuario.nome || "n/i"}</li>
                    <li style={{ color: "#000" }}>{usuario.email || "n/i"}</li>
                    <li style={{ color: "#000" }}>{usuario.cpf || "n/i"}</li>
                  </ul>
                </div>
                <div className="item item-divider item-positive">
                  Dispositivo
                </div>
                <div className="item item-text-wrap">{navigator.userAgent}</div>
                <div className="item item-divider item-positive">
                  Informações da tela
                </div>
                <div className="item item-text-wrap">
                  Dimensões: {window.innerWidth}px por {window.innerHeight}
                  px
                  <br />
                  Densidade pixels: {window.devicePixelRatio}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Corpo>
  );
}
